import React from "react";
import AboutDiv from "../css/About.styled";
import { Fade } from "react-awesome-reveal";
import Aboutme from "../assets/icons/aboutme.svg";
import AboutPic from "../assets/image/aboutPic.webp";
const About = () => {
  return (
    <AboutDiv id="about">
      <div className="conatainerAbout">
        {/* <div className="iconContainer"> */}
        <Fade direction="left" className="iconContainer">
          <img className="iconAboutMe" src={AboutPic} alt="" />
        </Fade>
        {/* </div> */}

        <div className="aboutDesc">
          <Fade direction="left">
            <h1 className="subTitle">About me</h1>
            <p className="desc">
              Experienced in Node.js, JavaScript, TypeScript, Golang, 
              React.js and working with multiple databases including PostgreSQL, 
              Snowflake, MongoDB, Redshift, and Redis. Skilled in AWS cloud services, 
              Kubernetes (Argo CD, Argo Workflows), and event-driven distributed systems.
            </p>
          </Fade>
        </div>
      </div>
    </AboutDiv>
  );
};

export default About;

// "https://raw.githubusercontent.com/mandarsatam/mandarsatam.github.io/9e9c534e75dd8ac2732b3ec472ce6c2817df9971/static/media/aboutmePic.79439da1.svg"
